export default __webpack_public_path__ + "cog-wheel-silhouette.png";